import { LabelModel } from '../../models/labels/label.model';
import { ChapterModel } from '../../models/chapter.model';
import { LabelCollapseModeEnum } from '../../models/labels/label-collapse-mode';

import { LabelThemeEnum } from '../../models/labels/label-theme.enum';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';


export class PatchLabels {
  static readonly type = '[Story Labels] Patch Labels';
  constructor(public patches: Patch[]) {}
}

export class SetLabelOffset {
  static readonly type = '[Story Labels] Set label Offset';
  constructor(public labelId: string, public offset: [number, number]) {}
}

export class SetLabels {
  static readonly type = '[Story Labels] Set Labels';
  constructor(public labels: LabelModel[]) { }
}

export class AddLabel {
  static readonly type = '[Story Labels] Add Label';
  constructor(public label: LabelModel) { }
}

export class AddContextLabel {
  static readonly type = '[Story Labels] Set Contexdt Label';
  constructor(public label: LabelModel) { }
}

export class CopyLabels {
  static readonly type = '[Story Labels] Copy Labels';
  constructor(public sourceChapter: ChapterModel, public targetChapter: ChapterModel) { }
}

export class RemoveLabel {
  static readonly type = '[Story Labels] Remove Label';
  constructor(public label: LabelModel) { }
}

export class RemoveContextLabel {
  static readonly type = '[Story Labels] Remove Context Label';
  constructor() { }
}


export class RemoveAllChapterLabels {
  static readonly type = '[Story Labels] Remove All Chapter Labels';
  constructor(public chapter: ChapterModel) { }
}

export class SetLabel {
  static readonly type = '[Story Labels] Set Label';
  constructor(public label: LabelModel, public record: boolean = false) { }  
}

export class SetLabelStates {
  static readonly type = '[Story Labels] Set Label States';
  constructor(public id: LabelModel['id'], public states: LabelModel['states']) {}
}

export class SetLabelScale {
  static readonly type = '[Story Labels] Set Label Scale';
  constructor(public scale: number) {}
}

export class SelectLabel {
  static readonly type = '[Story Labels] Select Label';
  constructor(public label?: LabelModel) { }
}

export class ResetLabels {
  static readonly type = '[Story Labels] Reset';
  constructor() { }
}

export class ConvertLabels {
  static readonly type = '[Story Labels] Convert';
  constructor(public labels: LabelModel[], public fields: Partial<LabelModel>) { }
}

export class EnableContextLabel {
  static readonly type = '[Story Labels] Enable Context Label';
  constructor(public enable: boolean, public enableInfo = true, public enableActions = true) { }
}

export class SetLabelsShown {
  static readonly type = '[Story Labels] Set Labels Shown';
  constructor(public labels: LabelModel[], public shown: boolean) { }  
}

export class SetAllLabelsShown {
  static readonly type = '[Story Labels] Set All Labels Shown';
  constructor(public show: boolean) { }  
}

export class SetLabelsCollapsed {
  static readonly type = '[Story Labels] Set Labels Collapsed';
  constructor(public collapsed: boolean, public collapsedMode: LabelCollapseModeEnum = LabelCollapseModeEnum.None) { }  
}

export class SetLabelsDraggable {
  static readonly type = '[Story Labels] Set Draggable';
  constructor(public draggable: { tag: boolean; pin: boolean }) { }  
}
